import React from 'react';
import { useEffect, useState } from 'react';
import './ChickenPage.css';
import Button from './Button';
import AnimeChicken from './AnimeChicken.js';
import { Link, useParams } from "react-router-dom";
import Box from './Box';


function ChickenPage(props) {
  const [menu, setMenu] = useState(false);
  const API = props.api;
  const tokenId = useParams().tokenId
  // trigger on component mount
  useEffect(() => {
    API.setQueryTokenId(tokenId);
  }, [tokenId]);

  useEffect(() => {
    API.fetchMetadata();
    API.fetchClaimablEth();
    API.fetchClaimableEggToken();
    API.fetchOwner();
    API.fetchOffspringCount();
    API.fetchMultiplier();
    API.fetchLatestTokenId();
    API.fetchBaseBonus();
  }, [API.queryTokenId]); // set dependency array to queryTokenId to update every time queryTokenId changes

  return (
    <div className='chickenPageClass'>
      <div className='panel'>
        <div className='centerBar'>
          <h1>Chicken #{tokenId}</h1>

          {API.currentAccount ?
            <Button onClick={API.mintNftHandler}> Mint from chicken #{API.queryTokenId} </Button>
            :
            <Button onClick={API.connectWalletHandler} className='pixel-button connect-wallet-button'>
              Connect Wallet to breed
            </Button>}
        </div>

        <div className='sideBar'>
          <ul >
            <li>{API.currentAccount &&
              <Link to={`/wallet/${API.currentAccount}`}>
                <Button >
                  {API.isOwner() ? 'Owner ' : 'Visitor '} {API.currentAccount.slice(0, 5)}... <img src={'img/wallet icon 64.png'} />
                </Button>
              </Link>
            }</li>
            <li><Box > Lv. {`${(API.multiplier - 100).toFixed(0)}`} </Box></li>
            <li><Button onClick={API.claimEthTokenHandler} > {API.isOwner() && ''} {API.claimablEth.toFixed(4)} <img src={'img/eth icon 64.png'} /></Button></li>
            <li><Button onClick={API.ClaimEggTokenHandler} > {API.isOwner() && ''} {API.claimablEgg.toFixed(4)} <img src={'img/goldegg icon 64.png'} /></Button></li>
            <li><Button onClick={() => setMenu((pre) => !pre)} > Attr.  <img src={'img/chick icon 64.png'} /></Button></li>

            <li>
              <Link to={`/`}>
                <Button>
                  <img src='img/home-icon.svg' style={{ height: '20px' }}></img>
                </Button>
              </Link>
            </li>
            
          </ul>
        </div>

      </div>


      {menu ?
        <div className='menu-panel'>

          <Box nonClick={true}>  <img src={'img/chick icon 64.png'} /> <br />
            <Box >
              <div className='attribute'>
                <p>{`Level: ${(API.multiplier - 100).toFixed(2)}`}</p>
                <p>{`Gold Egg: ${API.claimablEgg.toFixed(6)}`}</p>
                <p>{`Eth: ${API.claimablEth.toFixed(6)}`}</p>
                <p>{`Offspring: ${API.offspringCount}`}</p>
                <p>{`Days since last claim: ${API.baseBonus.toFixed(5)}`}</p>
              </div>
            </Box>
            <br /><br />
            <p>We the chicken, the breeder can breed us to earn ETH by showing this page for others to mint.
              Meanwhile hold the chicken to earn gold egg.
              Everytime a chicken is minted, 30% goes to the seller, 60% goes to the community by burning gold egg token, and 10% for running this project.
            </p>
            <br />
            <p>Days x (1 + Lv.%) = Gold egg <img src={'img/goldegg icon 64.png'} style={{ height: '30px', verticalAlign: 'middle' }} /></p> <br />
            <p>A chicken lay 1 egg per day and multiply with your level is the claimable gold eggs. The multiply apply to all the eggs, so don't claim too early.</p>
            <br />
            <p>sq. root(<img src={'img/offspring icon 64.png'} style={{ height: '30px', verticalAlign: 'middle' }} /> offspring ) = Lv.</p>
            <br />
            <p>Level is the square root of offspring, that is the num. of children and grandchildren and so on… The more you breed the higher the level.</p>
            <br />

            <ul >
              {API.isOwner() && <li><Button onClick={API.claimEthTokenHandler} >
                {API.isOwner() && 'Claim'} {API.claimablEth.toFixed(4)} <img src={'img/eth icon 64.png'} /></Button></li>
              }
              {API.isOwner() && <li><Button onClick={API.ClaimEggTokenHandler} >
                {API.isOwner() && 'Claim'} {API.claimablEgg.toFixed(4)} <img src={'img/goldegg icon 64.png'} /></Button></li>}

              <li><Button onClick={() => setMenu((pre) => !pre)} > Close </Button></li>
            </ul>
          </Box>

        </div>
        : null}
      {/*
        <li><Button > Offspring {API.offspringCount} <img src={'img/offspring icon 64.png'} /></Button></li>
        <li><Button > baseBonus {`${API.baseBonus.toFixed(5)}`}  <img src={'img/chick icon 64.png'} /></Button></li>
        <Button > Offspring {API.offspringCount} <img src={'img/offspring icon 64.png'} /></Button>
        <Button > baseBonus {`${API.baseBonus.toFixed(5)}`}  <img src={'img/chick icon 64.png'} /></Button>
      */}

      <AnimeChicken tokenId={tokenId} />
    </div>
  )
}

export default ChickenPage;
